import { useContext } from "react";
import { PermissionsContext } from "./context";
import type { MenuItem } from "../../hooks/dto";
import type { ExtraPermissionOption } from "./dto";
/**
 * 获取权限上下文
 */
export const usePermissions = (): [
  string[],
  MenuItem[],
  ExtraPermissionOption
] => {
  const { permissionList, menu, publicPermissionList, authMenuList } =
    useContext(PermissionsContext);

  return [permissionList, menu, { publicPermissionList, authMenuList }];
};
